const customerUpdateMeQuery = require('../../queries/user/customerUpdateMeQuery');
const { clientMutate } = require('../queries');
const handleCtApiError = require('../handleCtApiError');

/**
 * @param {Context} context
 * @param {Customer} currentUser
 * @param {Address} address
 */
const setDefaultBillingAddress = async (context, currentUser, address) => {
  if (!address.id) {
    throw new Error('Address ID is required to set default billing address.');
  }

  const actions = [
    {
      setDefaultBillingAddress: {
        addressId: address.id,
      },
    },
  ];

  const options = {
    mutation: customerUpdateMeQuery,
    variables: {
      version: currentUser.version,
      actions,
    },
    fetchPolicy: 'no-cache',
  };

  try {
    const updateResponse = await clientMutate(context, options);

    return updateResponse;
  } catch (error) {
    throw handleCtApiError(error);
  }
};

module.exports = setDefaultBillingAddress;
